export default __webpack_public_path__ + "static/media/fence3.815ee040.jpeg";